module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"house":"Huis","apartment":"Appartement"},"nl-BE":{"house":"Huis","apartment":"Appartement"},"es-ES":{"house":"Casa","apartment":"Apartamento"},"de-DE":{"house":"Haus","apartment":"Wohnung"},"fr-BE":{"house":"Maison","apartment":"Appartement"},"fr-FR":{"house":"Maison","apartment":"Appartement"}}')
  delete Component.options._Ctor
}
